import angularIcon from './angular.svg'
import cssIcon from './css.png'
import htmlIcon from './html.png'
import jsIcon from './javascript.png'
import nextIcon from './nextjs.svg'
import reactIcon from './reactjs.png'
import reduxIcon from './redux.png'
import tailwindicon from './tailwind.png'
import viteIcon from './vite.svg'
import vueIcon from './vue.png'
import webpackIcon from './webpack.png'

const ICONS= {
    angularIcon,cssIcon,htmlIcon,jsIcon,nextIcon,reactIcon,reduxIcon,tailwindicon,viteIcon,vueIcon,webpackIcon 
} 

export const FRONTEND_ICONS_ARRAY = [angularIcon, cssIcon, htmlIcon, jsIcon, nextIcon, reactIcon, reduxIcon, tailwindicon, viteIcon, vueIcon, webpackIcon];
export default ICONS